import React from 'react'

/**
 * Onboarding icon system.
 *
 * Two families, no emoji:
 * - Glyph tiles: a single Chinese character set in a kai (brush) face on a
 *   seal-like tile — the brand-true mark for option cards.
 * - Line icons: hand-drawn 1.5px-stroke SVGs for everything else.
 */

export const Glyph = ({ char }: { char: string }) => (
  <span className='ob-glyph' lang='zh' aria-hidden='true'>
    {char}
  </span>
)

const lineProps = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true as const,
}

export const BookIcon = () => (
  <svg {...lineProps}>
    <path d='M12 6.5C10.6 4.9 8.6 4 6.2 4c-1 0-2 .15-2.7.4V18.6c.7-.25 1.7-.4 2.7-.4 2.4 0 4.4.9 5.8 2.5 1.4-1.6 3.4-2.5 5.8-2.5 1 0 2 .15 2.7.4V4.4c-.7-.25-1.7-.4-2.7-.4-2.4 0-4.4.9-5.8 2.5z' />
    <path d='M12 6.5v14.2' />
  </svg>
)

export const TapIcon = () => (
  <svg {...lineProps}>
    <path d='M9.5 11.2V5.6a1.9 1.9 0 0 1 3.8 0v5.2l3.6.9c1.1.3 1.8 1.3 1.7 2.4l-.4 3.6a3 3 0 0 1-3 2.7h-3.1a3 3 0 0 1-2.3-1.1l-3.4-4.1a1.6 1.6 0 0 1 2.3-2.2l.8.7' />
    <path d='M7.2 6.5a4.6 4.6 0 0 1 8.4-1.8' opacity='0.55' />
  </svg>
)

export const LayersIcon = () => (
  <svg {...lineProps}>
    <path d='M12 3.8 20.5 8 12 12.2 3.5 8 12 3.8z' />
    <path d='M4.6 12.1 12 15.8l7.4-3.7' opacity='0.7' />
    <path d='M4.6 16.1 12 19.8l7.4-3.7' opacity='0.4' />
  </svg>
)

export const CheckIcon = ({ size = 13 }: { size?: number }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.6' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
    <path d='M20 6L9 17l-5-5' />
  </svg>
)

/** 1–3 filled bars; reads as a difficulty meter without words or emoji. */
export const DifficultyIcon = ({ level }: { level: 1 | 2 | 3 }) => (
  <svg width='26' height='18' viewBox='0 0 26 18' aria-hidden='true'>
    {[0, 1, 2].map((i) => (
      <rect
        key={i}
        x={2 + i * 8}
        y={12 - i * 5}
        width='5'
        height={4 + i * 5}
        rx='1.5'
        fill={i < level ? 'currentColor' : 'none'}
        stroke='currentColor'
        strokeWidth='1.4'
        opacity={i < level ? 1 : 0.35}
      />
    ))}
  </svg>
)
